<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <time-show/>
    <div class="rightNav">
      <lang-select></Lang-select>
      <div><el-tag v-model="username" style="display:block;margin:0 auto;margin-top: 15px">{{ username }}</el-tag></div>
      <div class="right-menu">
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <div class="userLogin">
              <i class="el-icon-user-solid"></i>
            </div>
            <i class="el-icon-caret-bottom" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided>
                <span style="display:block;" @click="logout">登出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'
import Hamburger from 'components/Hamburger'
import LangSelect from '@/components/langselect'
import TimeShow from '@/components/timeshow'
import cookie from '@/utils/cookie'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect,
    TimeShow
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])

  },
  // eslint-disable-next-line vue/order-in-components
  data() {
    return {
      username: ''
    }
  },

  mounted() {
    this.username = cookie.getCookie(cookie.username_cookie)
  },
  // eslint-disable-next-line vue/order-in-components
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    showUserName() {
      const username = cookie.getCookie(cookie.username_cookie)
      console.log(username)
    }
  }
}
</script>

<style lang="scss" scoped>
.rightNav{
  display: flex;
  height: 50px;
  width: 140px;
  float: right;
}
.userLogin{
      height: 20px;
    line-height: 20px;
    width: 20px;
    background-color: #fff;
    margin-top: 10px;
    display: inline-block;
    border: 1px solid #fff;
    border-radius: 4px;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #1E65AF;
  box-shadow: 0 1px 4px #095083;

  .hamburger-container {
    color: #fff;
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgb(61, 135, 189)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 40px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue